import React from 'react';
import '../../assets/scss/style.scss';

const DefaultTheme = () => {
  return <></>;
};

export default DefaultTheme;
